import type { JSX } from 'react';

export const STYLE_FILTERS = [
  'All',
  'Pattachitra',
  'Madhubani',
  'Expressions',
  'Replicas',
  'Floral',
  'Impressionist',
  'Reflections',
  'Folk Life',
  'Stylized',
  'Still Life',
  'Abstract',
  'Landscape',
] as const;

export type StyleFilter = (typeof STYLE_FILTERS)[number];

interface StyleFiltersProps {
  activeFilter: StyleFilter;
  onFilter: (filter: StyleFilter) => void;
}

export default function StyleFilters({ activeFilter, onFilter }: StyleFiltersProps): JSX.Element {
  return (
    <div className="flex flex-wrap gap-2 px-4 py-6">
      {STYLE_FILTERS.map((filter) => {
        const isActive = filter === activeFilter;
        return (
          <button
            key={filter}
            type="button"
            onClick={() => {
              onFilter(filter);
            }}
            className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${
              isActive
                ? 'border-blue-600 text-blue-600'
                : 'border-neutral-900 text-neutral-900 hover:bg-neutral-100'
            }`}
          >
            {filter}
          </button>
        );
      })}
    </div>
  );
}
